import { combineReducers } from 'redux';
import {
    PreferredLanguageFetchSuccessActionType,
} from '../Language/languageAction';

import {
    ApplicationContextFetchFailureActionType,
    ApplicationContextFetchRequestActionType,
    ApplicationContextFetchSuccessActionType,
} from 'store/AppContext/applicationContextAction';

import { ActionType } from 'store/ActionType';
import { ApplicationContext } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';

const context = (
    state: Nullable<ApplicationContext> = null,
    action: ActionType,
) => {
    switch (action.type) {
        case ApplicationContextFetchSuccessActionType: {
            return action.payload;
        }
        case PreferredLanguageFetchSuccessActionType: {
            return {
                ...state,
                preferredLanguage: action.payload,
            };
        }
        default: {
            return state;
        }
    }
};

const isLoading = (state = false, action: ActionType) => {
    switch (action.type) {
        case ApplicationContextFetchRequestActionType: {
            return true;
        }
        case ApplicationContextFetchFailureActionType:
        case ApplicationContextFetchSuccessActionType: {
            return false;
        }
        default: {
            return state;
        }
    }
};

export default combineReducers({
    context,
    isLoading,
});
